//auth
export const LOG_IN_REQUEST = 'LOG_IN_REQUEST';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAILED = 'LOG_IN_FAILED';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const LOG_IN_CLEAR = 'LOG_IN_CLEAR';
export const PASSWORD_RECOVERY_REQUEST = 'PASSWORD_RECOVERY_REQUEST';
export const PASSWORD_RECOVERY_SUCCESS = 'PASSWORD_RECOVERY_SUCCESS';
export const PASSWORD_RECOVERY_FAILURE = 'PASSWORD_RECOVERY_FAILURE';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
export const RESET_PASSWORD_CLEAR = 'RESET_PASSWORD_CLEAR';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILED = 'GET_USER_FAILED';
export const GET_USER_CLEAR = 'GET_USER_CLEAR';
export const CHANGE_USER_EMAIL_REQUEST = 'CHANGE_USER_EMAIL_REQUEST';
export const CHANGE_USER_EMAIL_SUCCESS = 'CHANGE_USER_EMAIL_SUCCESS';
export const CHANGE_USER_EMAIL_FAILED = 'CHANGE_USER_EMAIL_FAILED';
export const CHANGE_CLEAR = 'CHANGE_CLEAR';
export const CHANGE_USER_PASSWORD_REQUEST = 'CHANGE_USER_PASSWORD_REQUEST';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_FAILED = 'CHANGE_USER_PASSWORD_FAILED';
export const CHANGE_USER_PASSWORD_CLEAR = 'CHANGE_USER_PASSWORD_CLEAR';
export const CHANGE_PERSONAL_DATA_REQUEST = 'CHANGE_PERSONAL_DATA_REQUEST';
export const CHANGE_PERSONAL_DATA_SUCCESS = 'CHANGE_PERSONAL_DATA_SUCCESS';
export const CHANGE_PERSONAL_DATA_FAILED = 'CHANGE_PERSONAL_DATA_FAILED';
export const CONFIRM_NEW_PASSWORD_REQUEST = 'CONFIRM_NEW_PASSWORD_REQUEST';
export const CONFIRM_NEW_PASSWORD_SUCCESS = 'CONFIRM_NEW_PASSWORD_SUCCESS';
export const CONFIRM_NEW_PASSWORD_FAILED = 'CONFIRM_NEW_PASSWORD_FAILED';
export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';
//user
export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';
export const ADD_USER_CLEAR = 'ADD_USER_CLEAR';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const GET_INVESTMENTS_REQUEST = 'GET_INVESTMENTS_REQUEST';
export const GET_INVESTMENTS_SUCCESS = 'GET_INVESTMENTS_SUCCESS';
export const GET_INVESTMENTS_FAILED = 'GET_INVESTMENTS_FAILED';
export const GET_INSTALLMENT_CLEAR = 'GET_INSTALLMENT_CLEAR';
export const GET_INVESTMENTS_WITHDRAWALS_CLEAR =
    'GET_INVESTMENTS_WITHDRAWALS_CLEAR';
export const GET_INVESTMENTS_WITHDRAWALS_REQUEST =
    'GET_INVESTMENTS_WITHDRAWALS_REQUEST';
export const GET_INVESTMENTS_WITHDRAWALS_SUCCESS =
    'GET_INVESTMENTS_WITHDRAWALS_SUCCESS';
export const GET_INVESTMENTS_WITHDRAWALS_FAILED =
    'GET_INVESTMENTS_WITHDRAWALS_FAILED';
export const UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_PROFILE_REQUEST';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILED = 'UPDATE_USER_PROFILE_FAILED';
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FORBIDDEN = 'DELETE_USER_FORBIDDEN';
export const GET_CREATED_USER_REQUEST = 'GET_CREATED_USER_REQUEST';
export const GET_CREATED_USER_SUCCESS = 'GET_CREATED_USER_SUCCESS';
export const GET_CREATED_USER_FAILED = 'GET_CREATED_USER_FAILED';
export const GET_CREATED_USER_CLEAR = 'GET_CREATED_USER_CLEAR';
export const GET_ALL_INSTALLMENTS_REQUEST = 'GET_ALL_INSTALLMENTS_REQUEST';
export const GET_ALL_INSTALLMENTS_SUCCESS = 'GET_ALL_INSTALLMENTS_SUCCESS';
export const GET_ALL_INSTALLMENTS_FAIL = 'GET_ALL_INSTALLMENTS_FAIL';
export const GET_ALL_WITHDRAWAL_REQUEST = 'GET_ALL_WITHDRAWAL_REQUEST';
export const GET_ALL_WITHDRAWAL_SUCCESS = 'GET_ALL_WITHDRAWAL_SUCCESS';
export const GET_ALL_WITHDRAWAL_FAIL = 'GET_ALL_WITHDRAWAL_FAIL';
//groups
export const ADD_GROUP_REQUEST = 'ADD_GROUP_REQUEST';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const ADD_GROUP_FAILED = 'ADD_GROUP_FAILED';
export const ADD_GROUP_CLEAR = 'ADD_GROUP_CLEAR';
export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILED = 'UPDATE_GROUP_FAILED';
export const UPDATE_GROUP_CLEAR = 'UPDATE_GROUP_CLEAR';
export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';
export const GET_GROUP_REQUEST = 'GET_GROUP_REQUEST';
export const GET_GROUP_SUCCESS = 'GET_GROUP_SUCCESS';
export const GET_GROUP_FAILED = 'GET_GROUP_FAILED';
export const GET_GROUP_CLEAR = 'GET_GROUP_CLEAR';
export const GET_GROUP_REQUEST_SYMBOLS = 'GET_GROUP_REQUEST_SYMBOLS';
export const GET_GROUP_SUCCESS_SYMBOLS = 'GET_GROUP_SUCCESS_SYMBOLS';
export const GET_GROUP_FAILED_SYMBOLS = 'GET_GROUP_FAILED_SYMBOLS';
export const GET_GROUP_CLEAR_SYMBOLS = 'GET_GROUP_CLEAR_SYMBOLS';
export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILED = 'GET_GROUPS_FAILED';
export const GET_GROUPS_CLEAR = 'GET_GROUPS_CLEAR';
//realized gain
export const GET_REALIZED_GAIN_REQUEST = 'GET_REALIZED_GAIN_REQUEST';
export const GET_REALIZED_GAIN_SUCCESS = 'GET_REALIZED_GAIN_SUCCESS';
export const GET_REALIZED_GAIN_FAILED = 'GET_REALIZED_GAIN_FAILED';
// symbols
export const GET_SYMBOLS_REQUEST = 'GET_SYMBOLS_REQUEST';
export const GET_SYMBOLS_SUCCESS = 'GET_SYMBOLS_SUCCESS';
export const GET_SYMBOLS_FAILED = 'GET_SYMBOLS_FAILED';
export const ADD_SYMBOL_REQUEST = 'ADD_SYMBOL_REQUEST';
export const ADD_SYMBOL_SUCCESS = 'ADD_SYMBOL_SUCCESS';
export const ADD_SYMBOL_FAILED = 'ADD_SYMBOL_FAILED';
export const ADD_SYMBOL_CLEAR = 'ADD_SYMBOL_CLEAR';
export const GET_SYMBOLS_CLEAR = 'GET_SYMBOLS_CLEAR';
export const DELETE_SYMBOL_REQUEST = 'DELETE_SYMBOL_REQUEST';
export const DELETE_SYMBOL_SUCCESS = 'DELETE_SYMBOL_SUCCESS';
export const DELETE_SYMBOL_FAILED = 'DELETE_SYMBOL_FAILED';
//lots
export const GET_LOTS_LIST_REQUEST = 'GET_LOTS_LIST_REQUEST';
export const GET_LOTS_LIST_SUCCESS = 'GET_LOTS_LIST_SUCCESS';
export const GET_LOTS_LIST_FAILED = 'GET_LOTS_LIST_FAILED';
export const GET_LOTS_LIST_CLEAR = 'GET_LOTS_LIST_CLEAR';
export const DELETE_LOT_REQUEST = 'DELETE_LOT_REQUEST';
export const DELETE_LOT_SUCCESS = 'DELETE_LOT_SUCCESS';
export const DELETE_LOT_FAILED = 'DELETE_LOT_FAILED';
export const ADD_LOT_REQUEST = 'ADD_LOT_REQUEST';
export const ADD_LOT_CLEAR = 'ADD_LOT_CLEAR';
export const ADD_LOT_SUCCESS = 'ADD_LOT_SUCCESS';
export const ADD_LOT_FAILED = 'ADD_LOT_FAILED';
export const SELL_LOT_REQUEST = 'SELL_LOT_REQUEST';
export const SELL_LOT_SUCCESS = 'SELL_LOT_SUCCESS';
export const SELL_LOT_FAILED = 'SELL_LOT_FAILED';
export const SELL_LOT_CLEAR = 'SELL_LOT_CLEAR';
//cash
export const GET_CASH_REQUEST = 'GET_CASH_REQUEST';
export const GET_CASH_SUCCESS = 'GET_CASH_SUCCESS';
export const GET_CASH_FAILED = 'GET_CASH_FAILED';
export const CASH_OUT_REQUEST = 'CASH_OUT_REQUEST';
export const CASH_OUT_SUCCESS = 'CASH_OUT_SUCCESS';
export const CASH_OUT_FAILED = 'CASH_OUT_FAILED';
export const GET_TRANSACTIONS_REQUEST = 'GET_TRANSACTIONS_REQUEST';
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
export const GET_TRANSACTIONS_FAIL = 'GET_TRANSACTIONS_FAIL';
export const GET_TRANSACTIONS_CLEAR = 'GET_TRANSACTIONS_CLEAR';
//fund
export const GET_TOTAL_FUND_REQUEST = 'GET_TOTAL_FUND_REQUEST';
export const GET_TOTAL_FUND_SUCCESS = 'GET_TOTAL_FUND_SUCCESS';
export const GET_TOTAL_FUND_FAILED = 'GET_TOTAL_FUND_FAILED';
//add investment
export const ADD_INVESTMENT_REQUEST = 'ADD_INVESTMENT_REQUEST';
export const ADD_INVESTMENT_SUCCESS = 'ADD_INVESTMENT_SUCCESS';
export const ADD_INVESTMENT_FAILED = 'ADD_INVESTMENT_FAILED';
//user holding
export const GET_USER_HOLDING_REQUEST = 'GET_USER_HOLDING_REQUEST';
export const GET_USER_HOLDING_SUCCESS = 'GET_USER_HOLDING_SUCCESS';
export const GET_USER_HOLDING_FAILED = 'GET_USER_HOLDING_FAILED';
export const GET_USER_HOLDING_CLEAR = 'GET_USER_HOLDING_CLEAR';
